<template>
  <div class="app-body">
    <div class="template-box">
      <div class="line">{{ dataForm.dto.title }}</div>
      <div class="line">课程：{{ dataForm.dto.courseName }}</div>
      <div class="line">{{ dataForm.dto.remark }}</div>
    </div>
    <div class="form-box">
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
      >
        <el-form-item label="计划发布时间：" prop="planSendDate">
          <el-date-picker
            v-model="dataForm.planSendDate"
            type="datetime"
            placeholder="请选择计划发布时间"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="标题：">
          <el-input
            v-model="dataForm.dto.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="课程：">
          <el-input
            v-model="dataForm.dto.courseName"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="详情：">
          <el-input
            type="textarea"
            :rows="5"
            v-model="dataForm.dto.remark"
            placeholder="请输入详情"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="submit"
            >发送</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    studentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      dataForm: {
        dto: {
          title: "你好，以下课程将在15分钟后开始",
          courseName: "英语4级",
          remark: "若因故无法参加，请及时联系老师",
        },
        planSendDate: "",
        studentIds: [],
      },
      dataRule: {
        planSendDate: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    timeFormatter(time) {
      if (!time) {
        return "";
      }
      let m = this.$moment(time);
      return m.format("yyyy年MM月DD日 HH:mm");
    },
    submit() {
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.sendHandle();
      });
    },
    sendHandle() {
      if (!this.studentList || this.studentList.length === 0) {
        this.$message.error("请选择要发送的学生");
        return;
      }
      let postForm = {
        ...this.dataForm,
      };
      postForm.studentIds = this.studentList.map((item) => item.id);
      this.$http
        .post("/yxs/notice/send/class", postForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.$message.error(res.msg);
            return;
          }
          this.$message.success("发送成功");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-body {
  display: flex;
  .template-box {
    width: 400px;
    border: solid 1px #e3e4e5;
    padding: 20px;
    .line {
      padding: 6px 0;
      line-height: 24px;
    }
  }
  .form-box {
    flex: 1;
  }
}
</style>
